import React, { useState, useEffect } from 'react';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import Chip from '@mui/material/Chip';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import StarIcon from '@mui/icons-material/Star';
import { MAIN_BLUE } from '../../color';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  AccordionDetails,
  Accordion,
  AccordionSummary,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { approveSkill } from '../Services/SkillsService';
import moment from 'moment';
import KeycloakService from '../../services/KeycloakService';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import { DialogBoxComponent } from '../../components/DialogBox/DialogBoxCard';

const ApproveSkillCardComponent = ({ skill }) => {
  const [expanded, setExpanded] = useState(false);
  const [editing, setIsEditing] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selectedRating, setSelectedRating] = useState(skill.selfRating);
  const currentUserId = KeycloakService.getUserDetail();
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {}, [refresh]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handleEditClick = () => {
    setSelectedRating(
      skill.approvedRating === null ? skill.selfRating : skill.approvedRating,
    );
    setIsEditing(true);
  };

  const handleRatingChange = (event) => {
    setSelectedRating(event.target.value);
  };
  const handleCheck = () => {
    skill.approvedRating = selectedRating;
    setIsEditing(false);
  };
  const handleCancelEdit = (event) => {
    setIsEditing(false);
  };

  const createReqBody = () => {
    const bodyJSON = {
      skillEmployeeMappingId: skill.id,
      approvedRating:
        skill.approvedRating === null ? skill.selfRating : skill.approvedRating,
      approverId: currentUserId,
      approvalDate: moment().format('YYYY-MM-DD').toString(),
    };
    return bodyJSON;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnConfirm = async () => {
    setOpen(false);
    setLoadingApiCall(true);
    const reqBody = createReqBody();
    const response = await approveSkill(reqBody);
    setLoadingApiCall(false);
    if (response.isError === false) {
      skill.status = 'APPROVED';
      setRefresh(true);
      skill.approvedRating =
        skill.approvedRating === null ? skill.selfRating : skill.approvedRating;
    }
    dipatchNotification(response.type, response.message);
  };

  const handleApproveClick = async () => {
    setOpen(true);
  };

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <Grid container className="space-between-container pb-0">
        <DialogBoxComponent
          open={open}
          handleClose={handleClose}
          confirmText={'Approve'}
          cancelText={'Close'}
          content={'Are you sure, you want to approve this skill mapping?'}
          onConfirm={handleOnConfirm}
          onCancel={handleClose}
          icon={<FlakyOutlinedIcon color="primary" />}
        />
        <Grid item xs={4}>
          <CardHeader
            sx={{ paddingBottom: '0px' }}
            title={skill.employeeName}
            subheader={
              <>
                <Typography variant="subtitle1">{skill.skillName}</Typography>
                <Typography variant="subtitle2">
                  Requested Rating:{' '}
                  {skill.selfRating.charAt(0).toUpperCase() +
                    skill.selfRating.slice(1).toLowerCase()}
                </Typography>
                <Box display="flex" alignItems="center">
                  {skill.selfRating === 'BEGINNER' ||
                  skill.selfRating === 'INTERMEDIATE' ||
                  skill.selfRating === 'ADVANCED' ? (
                    <StarIcon sx={{ fill: MAIN_BLUE, height: '20px' }} />
                  ) : (
                    <StarBorderIcon sx={{ height: '20px' }} />
                  )}
                  {skill.selfRating === 'INTERMEDIATE' ||
                  skill.selfRating === 'ADVANCED' ? (
                    <StarIcon sx={{ fill: MAIN_BLUE, height: '20px' }} />
                  ) : (
                    <StarBorderIcon sx={{ height: '20px' }} />
                  )}
                  {skill.selfRating === 'ADVANCED' ? (
                    <StarIcon sx={{ fill: MAIN_BLUE, height: '20px' }} />
                  ) : (
                    <StarBorderIcon sx={{ height: '20px' }} />
                  )}
                </Box>
              </>
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{ width: '100%', textAlign: 'center', marginTop: '15px' }}
          >
            <CalendarMonthRoundedIcon fontSize="small" className="mr-1 mt-n1" />
            Duration: {skill.duration} Months
          </Typography>
          <div className="mt-2">
            <center>
              <Button
                variant="outlined"
                size="small"
                color="error"
                disabled={editing || skill.status === 'APPROVED' ? true : false}
                sx={{ px: 3, mr: 1 }}
                onClick={() => handleEditClick()}
              >
                Edit
              </Button>
              <LoadingButton
                variant="outlined"
                size="small"
                color="success"
                disabled={skill.status === 'APPROVED' ? true : false}
                loading={loadingApiCall}
                sx={{ px: 3 }}
                onClick={() => handleApproveClick()}
              >
                {loadingApiCall ? 'loading...' : 'Approve'}
              </LoadingButton>
            </center>
          </div>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3}>
          <Box sx={{ width: '100%', textAlign: 'right', marginTop: '5px' }}>
            <Chip
              sx={{ marginRight: 1.5 }}
              label={skill.status}
              color={skill.status === 'PENDING' ? 'warning' : 'success'}
              size="small"
              variant="outlined"
            />
          </Box>
          <Box sx={{ textAlign: 'right' }}>
            <Typography
              variant="subtitle2"
              sx={{ marginRight: 1.5 }}
              className="mt-1"
            >
              Approved Rating:{' '}
              {skill.approvedRating === null
                ? '---'
                : skill.approvedRating.charAt(0).toUpperCase() +
                  skill.approvedRating.slice(1).toLowerCase()}
            </Typography>
          </Box>
          {editing ? (
            <>
              <FormControl size="small" className="mt-2">
                <InputLabel id="ratingLabel">Approved Rating</InputLabel>
                <Select
                  label="Approved Rating"
                  labelId="ratingLabel"
                  variant="outlined"
                  sx={{ marginRight: 1.5, width: '170px' }}
                  value={selectedRating}
                  onChange={(event) => handleRatingChange(event)}
                >
                  <MenuItem value="">Select Rating</MenuItem>
                  <MenuItem value="BEGINNER">Beginner</MenuItem>
                  <MenuItem value="INTERMEDIATE">Intermediate</MenuItem>
                  <MenuItem value="ADVANCED">Advanced</MenuItem>
                </Select>
              </FormControl>
              <IconButton
                sx={{ paddingLeft: '0px' }}
                color="error"
                className="mt-2"
                onClick={() => handleCancelEdit()}
              >
                <CloseIcon />
              </IconButton>
              <IconButton
                sx={{ paddingLeft: '0px' }}
                color="secondary"
                className="mt-2"
                style={{ marginLeft: 'auto' }}
                onClick={() => handleCheck()}
              >
                <CheckIcon />
              </IconButton>
            </>
          ) : null}
        </Grid>
      </Grid>
      <CardContent
        sx={{ padding: '0px', '&:last-child': { paddingBottom: 0 } }}
      >
        <div>
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            disableGutters
            elevation={0}
            sx={{ width: '100%', pt: 0, pb: 0 }}
          >
            <Grid
              className="pb-0 pt-0"
              sx={{ display: 'flex', justifyContent: 'end' }}
            >
              <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
                <Typography variant="body2">Duration Summary</Typography>
              </AccordionSummary>
            </Grid>
            <AccordionDetails>
              {skill.datesArray.length !== 0 && (
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Serial Number</TableCell>
                        <TableCell>Start Month</TableCell>
                        <TableCell>End Month</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {skill.datesArray.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.startMonth}</TableCell>
                          <TableCell>
                            {row.endMonth ? row.endMonth : row.startMonth}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApproveSkillCardComponent;
